/**************************************************
 * Nombre:       DashboardBase
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {BrowserRouter} from "react-router";
import MenuLateral from "./MenuLateral";

const DashboardBase = ({secciones = [], seccionesPerfil = [], seccionesID = [], usuario = []}) => {
    const [seccionesProcesadas, setSeccionesProcesadas] = useState([])


    const obtenerCategorias = (secc) => {

        let categorias = secc.map((it) => it.categoria)
        let categoriasSet = new Set(categorias)
        return Array.from(categoriasSet)

    }

    const procesarSecciones = (cats, seccs) => {

        let arr = []

        for (let i = 0; i < cats.length; i++) {
            let obj = {
                categoria: cats[i]
            }
            let seccionesInternas = []
            for (let j = 0; j < seccs.length; j++) {

                let seccion = seccs[j]
                if (seccion.categoria === cats[i]) {
                    seccionesInternas.push(seccs[j])
                }
            }
            obj.secciones = seccionesInternas
            arr.push(obj)

        }

        return arr
    }

    const administramosAccesos = (secc, usu) => {

        let arr = []
        for (let i = 0; i < secc.length; i++) {
            if (!secc[i].privada) {
                arr.push(secc[i])
            } else if (secc[i].privada && usu.acceso && usu.acceso === 'Aprobado') {
                arr.push(secc[i])
            }
        }

        return arr

    }

    useEffect(() => {
        let categorias = obtenerCategorias(secciones)
        let seccionesAdministradas = administramosAccesos(secciones, usuario)
        let seccProcesadas = procesarSecciones(categorias, seccionesAdministradas)
        setSeccionesProcesadas(seccProcesadas)
    }, [secciones]);
    return (
        <Grid
            container
            size={12}
        >

            <BrowserRouter>
                <MenuLateral seccionesProcesadas={seccionesProcesadas} secciones={secciones}
                             seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </BrowserRouter>

        </Grid>
    )

}
export default DashboardBase